import { render, staticRenderFns } from "./appendix-fee-visa.vue?vue&type=template&id=39bf4452"
import script from "./appendix-fee-visa.vue?vue&type=script&lang=js"
export * from "./appendix-fee-visa.vue?vue&type=script&lang=js"
import style0 from "./appendix-fee-visa.vue?vue&type=style&index=0&id=39bf4452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports